export default __webpack_public_path__ + "static/media/willy.337e03f9.jpg";